// extracted by mini-css-extract-plugin
export default {"projectsSectionContainer":"styles_projectsSectionContainer__9SOue","projectsSectionTitle":"styles_projectsSectionTitle__AD52r"};